import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import UserLabResult from "components/user/user-lab-result/UserLabResult";
import { useDispatch, useSelector } from "react-redux";
import { test, testsuccessMessage } from "redux-store/lab-tests/tests.selecter";
import { getTests } from "redux-store/lab-tests/tests.slice";
import { AppDispatch } from "redux-store/store";
import React, { useEffect } from "react";
import UserAuth from "components/AuthGaurd/UserAuth";

const LabTests = () => {
  const tests = useSelector(test);
  const message = useSelector(testsuccessMessage);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getTests());
  }, []);

  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title="Lab Result">
        <UserLabResult labTests={tests} />
      </UserHeroSection>

      <footer className="tw-flex">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default LabTests;
